 // export const API_URL = "https://localhost:7232/";

export const API_URL = "https://api.psychooncology.online/";
